var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-holder"},[(_vm.loaded)?_c('div',{staticClass:"banner"},[_c('div',{style:({ 'background': 'url(' + _vm.image + ')', 'backgroundSize': 'cover', 'backgroundPosition': 'bottom', 'backgroundRepeat': 'no-repeat' }),domProps:{"innerHTML":_vm._s(_vm.html)}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }